import AffectedProductsEditor from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/AffectedProductsEditor/AffectedProductsEditor'
import BlockOptionsCheckboxes from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/BlockOptionsCheckboxes/BlockOptionsCheckboxes'
import { isTotalBlock } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/BlockOptionsCheckboxes/helpers'
import CustomMessage from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/PolicyRuleActionEditor/CustomMessage/CustomMessage'

import { blockCustomMessageTypeOptions } from '../constants'

const BlockOptionForProductConfig = ({
  config,
  onChangeConfig,
  disabled,
  currencies,
  storeCurrencyCode,
  productTypes,
  productCategories,
  productCollections,
  errors = [],
}) => {
  return (
    <>
      <BlockOptionsCheckboxes config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
      <AffectedProductsEditor
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        productTypes={productTypes}
        productCategories={productCategories}
        productCollections={productCollections}
      />
      <CustomMessage
        enabled={config.custom_message_enabled}
        message={config.custom_message}
        customMessageType={config.custom_message_type}
        customMessageTypeOptions={blockCustomMessageTypeOptions}
        customMessageTypeDisabled={isTotalBlock(config)}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        errors={errors}
      />
    </>
  )
}

export default BlockOptionForProductConfig
